/**
 * AiWorkflowService
 * Service for AI workflow session operations (start, confirm, create, cancel)
 */
import { BaseService } from '../base/BaseService';
export class AiWorkflowService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiWorkflowService.DEFAULT_SERVICE_PATH,
            basePath: AiWorkflowService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Start a workflow with text input only */
    async startWithText(request) {
        const formData = new FormData();
        formData.append('VendorID', request.vendorID.toString());
        formData.append('PresetID', request.presetID.toString());
        if (request.inputText)
            formData.append('InputText', request.inputText);
        const response = await this.http.post(this.buildUrl('start'), formData);
        if (!response.data)
            throw new Error('No data returned from workflow start');
        return response.data;
    }
    /** Start a workflow with a file (image/audio) upload */
    async startWithFile(vendorId, presetId, file) {
        const formData = new FormData();
        formData.append('VendorID', vendorId.toString());
        formData.append('PresetID', presetId.toString());
        formData.append('file', file);
        const response = await this.http.post(this.buildUrl('start'), formData);
        if (!response.data)
            throw new Error('No data returned from workflow start');
        return response.data;
    }
    /** Get a specific workflow session by ID */
    async getSession(sessionId) {
        const response = await this.http.get(this.buildUrl(`${sessionId}`));
        if (!response.data)
            throw new Error('Session not found');
        return response.data;
    }
    /** Get current user's sessions (raw response) */
    async getMySessionsRaw(vendorId = 0) {
        const params = vendorId !== 0 ? { vendorId } : {};
        return this.http.get(this.buildUrlWithParams('my-sessions', params));
    }
    /** Get current user's sessions */
    async getMySessions(vendorId = 0) {
        const response = await this.getMySessionsRaw(vendorId);
        return response.data ?? [];
    }
    /** Confirm extracted data for a session */
    async confirm(sessionId, confirmedJson) {
        const response = await this.http.post(this.buildUrl(`${sessionId}/confirm`), { confirmedJson });
        if (!response.data)
            throw new Error('No data returned from confirm');
        return response.data;
    }
    /** Create the target record from confirmed data */
    async createRecord(sessionId) {
        const response = await this.http.post(this.buildUrl(`${sessionId}/create-record`), {});
        if (!response.data)
            throw new Error('No data returned from create-record');
        return response.data;
    }
    /** Cancel/delete a workflow session */
    async cancel(sessionId) {
        const response = await this.http.delete(this.buildUrl(`${sessionId}`));
        return response.data ?? false;
    }
}
AiWorkflowService.DEFAULT_SERVICE_PATH = 'ai-management';
AiWorkflowService.BASE_PATH = 'api/ai/workflows';
//# sourceMappingURL=AiWorkflowService.js.map